(function () {
    'use strict';

    angular
        .module('appback')
        .controller('AppController', AppController)
        .controller('ContabilizarModalController', ContabilizarModalController);

    ContabilizarModalController.$inject = ['$uibModalInstance'];
    function ContabilizarModalController($uibModalInstance) {
        var vm = this;
        vm.fecha = new Date(); // Default to today
        vm.ok = function () {
            $uibModalInstance.close(vm.fecha);
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    AppController.$inject = ["PizarraService", "GenerallabService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "AccionesService"];

    function AppController(PizarraService, GenerallabService, $http, $timeout, $uibModal, $log, $document, $sce, AccionesService) {
        var vm = this;
        vm.avisos = [];
        vm.timers = {};
        vm.generalLab = GenerallabService;
        vm.isChatIAOpen = false;
        vm.newMessage = "";
        vm.conversacion = [];
        vm.conversacion.push({ msg: "Hola, ¿en qué puedo ayudarte?", class: "bot" });
        console.log("appcont");
        /*socket.on("pizarra:nuevacartaaviso",function(data){
            console.log("nuevacarta");
            //if(vm.esVisibleParaMi(data.carta)){
                vm.num_cartas++;
                console.log("ES VISIBLE");
                vm.avisos.push(data.carta);
                var index = vm.avisos.length-1;
                vm.timers[data.carta.id] = $timeout(function(){
                    vm.eliminarCarta(data.carta);
                },60000)
            //}
        })*/

        vm.toggleChatIA = function () {
            vm.isChatIAOpen = !vm.isChatIAOpen;
            var sidebar = document.getElementById('chatIASidebar');
            if (vm.isChatIAOpen) {
                sidebar.classList.add('open');
            } else {
                sidebar.classList.remove('open');
            }
        };

        /*document.querySelector('.close-chat-ia').addEventListener('click', function() {
            vm.toggleChatIA();
            //vm.$apply();
        });*/

        function scrollToBottom() {
            $timeout(function () {
                var chat = document.getElementById('chatMessages');
                if (chat) {
                    chat.scrollTop = chat.scrollHeight;
                }
            }, 100); // Tiempo corto para esperar el render
        }

        vm.sendConsultaIA = function () {
            if (vm.newMessage.trim() != "") {
                vm.conversacion.push({ msg: vm.newMessage, class: "user" });
                scrollToBottom();
                console.log("ENVIANDO CONSULTA A LA IA", vm.newMessage);
                AccionesService.sendConsultaIA(vm.newMessage, function (data) {
                    console.log("RESPUESTA DE LA IA", data.response);
                    if (data.response) {
                        vm.conversacion.push({ msg: data.response, class: "bot" });
                        scrollToBottom();
                    } else {
                        console.log("Error sendConsultaIA", data);
                    }
                });
            }
        }

        vm.handleKeyPress = function (event) {
            if (event.key === 'Enter') {
                vm.sendConsultaIA();
                vm.newMessage = "";
            }
        };

        vm.eliminarCarta = function (carta) {
            var res = false;
            for (var cont = 0; cont < vm.avisos.length && !res; cont++) {
                if (vm.avisos[cont].id == carta.id) {
                    vm.avisos.splice(cont, 1);
                    if (vm.timers[carta.id]) {
                        $timeout.cancel(vm.timers[carta.id]);
                    }
                }
            }
        }

        vm.init = function (username, categorias_ids) {
            vm.user_id = username;
            //socket.emit('pizarra:join', {room:'pizarra',username:username,categorias_ids:categorias_ids});
            PizarraService.getUsuarioCartas(function (data) {
                vm.num_cartas = data.num_cartas;
                vm.misCategorias = data.misCategorias;
            })
        }

        /*vm.esVisibleParaMi = function(carta){
            var res = false;
            var categorias_ids = [];
            for(var cont=0;cont<vm.misCategorias.length;cont++){
                categorias_ids.push(""+vm.misCategorias[cont].id);
            }

            console.log(categorias_ids,"cat_ids");
            console.log(carta.categoriapizarra_id,"cat");


            if(categorias_ids.indexOf(""+carta.categoriapizarra_id) !== -1 || carta.user_id==vm.user_id) {
                res = true;
            }
            return res;
        }*/
        vm.contabilizar = function (id) {
            console.log("CONTABILIZANDO", id);
            var modalInstance = $uibModal.open({
                templateUrl: 'contabilizarModal.html',
                controller: 'ContabilizarModalController',
                controllerAs: 'vm',
                resolve: {
                    id: function () {
                        return id;
                    }
                }
            });

            modalInstance.result.then(function (fecha) {
                if (fecha) {
                    var d = new Date(fecha);
                    var dateStr = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
                    window.location.href = '/backend/compra/contabilizar?id=' + id + '&fecha_contabilizacion=' + dateStr;
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
    }

})();